// La lista blanca de los banners del Inicio, la MISMA que usa la app: se
// importa tal cual su archivo (deja TCPromoWhitelist en global), así el
// backoffice guarda las huellas exactamente como las calcula la app.
//   parseList(texto) → { entries: [{ raw, kind, key }], invalid, overflow }
//   hashKeys(claves) → Promise<huellas>
//   cleanHashes(lista) → huellas limpias de un doc
import '../../../renderer/tabs/inicio/componentes/promo-lista-blanca.js';

export const PromoWhitelist = globalThis.TCPromoWhitelist;
